import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

function tratamentoResponse(response, chamada) {
    if (response.data.codErro > 0)
        return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
    else if (typeof response.data == "string" && response.data != "")
        return {
            retornoErro: 1,
            mensagem: chamada + " - Erro inesperado, entre em contato com os reponsáveis.",
        }
    else return response.data
}

const ErroRequisicao = function (data, aplicativoDados) {
    try {
        if (data.message == "Network Error") {
            return "Verifique sua conexão!"
        } else if (data.message) {
            return "Erro: " + data.message
        }
        return false
    } catch (error) {
        RegistrarLogErro(error, "ErroRequisicao", data)
    }
}

//Cadastrar
export const cadastrarCategoria = async (idCardapio, data, autorizacao, registrarHistorico = true) => {
    const url =
        `cardapio/categoria/cadastro/${idCardapio}` +
        (registrarHistorico ? "" : "?registrarHistorico=false")
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, data, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "cadastrarCategoria")
    } catch (error) {
        RegistrarLogErro(error, "cadastrarCategoria", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const cadastrarProduto = async (idCategoria, data, autorizacao, registrarHistorico = true) => {
    const url =
        `cardapio/produto/cadastro/${idCategoria}` +
        (registrarHistorico ? "" : "?registrarHistorico=false")
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api.post(url, data, { headers: headers }).catch(function (error) {
            const resp = ErroRequisicao(error)
            return { data: { codErro: 1, mensagem: resp } }
        })

        return tratamentoResponse(response, "cadastrarProduto")
    } catch (error) {
        RegistrarLogErro(error, "cadastrarProduto", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const cadastrarGrupoDeOpcao = async (idProduto, data, autorizacao, registrarHistorico = true) => {
    const url =
        `cardapio/grupoopcao/cadastro/${idProduto}` +
        (registrarHistorico ? "" : "?registrarHistorico=false")
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, data, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })

        return tratamentoResponse(response, "cadastrarGrupoDeOpcao")
    } catch (error) {
        RegistrarLogErro(error, "cadastrarGrupoDeOpcao", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const cadastrarOpcao = async (idGrupoOpcao, data, autorizacao, registrarHistorico = true) => {
    const url =
        `cardapio/opcao/cadastro/${idGrupoOpcao}` +
        (registrarHistorico ? "" : "?registrarHistorico=false")
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, data, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })

        return tratamentoResponse(response, "cadastrarOpcao")
    } catch (error) {
        RegistrarLogErro(error, "cadastrarOpcao", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

//Duplicar
export const duplicarCategoria = async (data, autorizacao) => {
    const url = "cardapio/categoria/duplicar"
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, data, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "duplicarCategoria")
    } catch (error) {
        RegistrarLogErro(error, "duplicarCategoria", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const duplicarProduto = async (data, autorizacao) => {
    const url = "cardapio/produto/duplicar"
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, data, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "duplicarProduto")
    } catch (error) {
        RegistrarLogErro(error, "duplicarProduto", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const duplicarGrupoDeOpcao = async (data, idProduto, autorizacao) => {
    const url = `cardapio/grupoopcao/duplicar/${idProduto}`
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, data, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "duplicarGrupoDeOpcao")
    } catch (error) {
        RegistrarLogErro(error, "duplicarGrupoDeOpcao", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

// Copia uma categoria (com produtos/opções) para o cardápio de outras lojas.
// Espelha a página Java CopiarCategoriaCardapio do sistemaadm: no backend, clona a
// categoria de origem e vincula ao cardápio de cada loja destino.
// ENDPOINT A CRIAR NO BACKEND: POST cardapio/categoria/copiar-para-lojas
// Body: { idCategoriaOrigem: number, idsLojasDestino: number[] }
// Retorno esperado: { copiadas: number, erros: [{ idLoja, nome, mensagem }] }
export const copiarCategoriaParaLojas = async (idCategoriaOrigem, idsLojasDestino, autorizacao) => {
    const url = "cardapio/categoria/copiar-para-lojas"
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }
    const data = { idCategoriaOrigem, idsLojasDestino }

    try {
        const response = await api.post(url, data, { headers }).catch(function (error) {
            const resp = ErroRequisicao(error)
            return { data: { codErro: 1, mensagem: resp } }
        })


        return tratamentoResponse(response, "copiarCategoriaParaLojas")
    } catch (error) {
        RegistrarLogErro(error, "copiarCategoriaParaLojas", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

// Excluir
export const excluirCategoria = async (data, autorizacao) => {
    const url = "cardapio/categoria/excluir"
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, data, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "excluirCategoria")
    } catch (error) {
        RegistrarLogErro(error, "excluirCategoria", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const excluirProduto = async (data, autorizacao) => {
    const url = "cardapio/produto/excluir"
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, data, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "excluirProduto")
    } catch (error) {
        RegistrarLogErro(error, "excluirProduto", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const excluirGrupoDeOpcao = async (data, autorizacao) => {
    const url = "cardapio/grupoopcao/excluir"
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, data, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "excluirGrupoDeOpcao")
    } catch (error) {
        RegistrarLogErro(error, "excluirGrupoDeOpcao", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const excluirOpcao = async (data, autorizacao) => {
    const url = "cardapio/opcao/excluir"
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, data, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "excluirOpcao")
    } catch (error) {
        RegistrarLogErro(error, "excluirOpcao", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

// Inativar

export const inativarProduto = async (idProduto, boolean, autorizacao) => {
    const url = `cardapio/produto/ativardesativar/${idProduto}/${!boolean}`
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "inativarProduto")
    } catch (error) {
        RegistrarLogErro(error, "inativarProduto")
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const inativarOpcao = async (idOpcao, boolean, autorizacao) => {
    const url = `cardapio/opcao/ativardesativar/${idOpcao}/${!boolean}`
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "inativarOpcao")
    } catch (error) {
        RegistrarLogErro(error, "inativarOpcao")
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const ativarInativarMassa = async (idEstabelecimento, data, autorizacao) => {
    const url = `cardapiosimplificado/ativardesativar/lista/${idEstabelecimento}`
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, data, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "inativarMassa ")
    } catch (error) {
        RegistrarLogErro(error, "inativarMassa ")
        return { retornoErro: 1, mensagem: error.message }
    }
}

//obter cardapio

export const obterCardapioParaEdicaoEmMassa = async (idEstabelecimento, autorizacao) => {
    const url = `cardapiosimplificado/${idEstabelecimento}`
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api.get(url, {
            headers: headers,
        })

        console.warn("obterCardapioParaEdicaoEmMassa =>", response)

        return tratamentoResponse(response, "obterCardapioParaEdicaoEmMassa")
    } catch (error) {
        console.error(error)
        RegistrarLogErro(error, "obterCardapioParaEdicaoEmMassa", {})
        return { retornoErro: 1, mensagem: error.message }
    }
}

//Salvar Cardapio completo

export const salvarCardapioCompleto = async (idEstabelecimento, data, autorizacao) => {
    const url = `cardapio/salvar/${idEstabelecimento}`
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api.post(url, data, {
            headers: headers,
        })

        console.warn("salvarCardapioCompleto =>", response)

        return tratamentoResponse(response, "salvarCardapioCompleto")
    } catch (error) {
        console.error(error)
        RegistrarLogErro(error, "salvarCardapioCompleto", {})
        return { retornoErro: 1, mensagem: error.message }
    }
}

//Cadastrar Imagem

export const cadastrarImagem = async (
    idEstabelecimento,
    nomeArquivo,
    idProduto,
    idOpcao,
    file,
    autorizacao
) => {
    const url =
        `cardapio/photo/${idEstabelecimento}/${nomeArquivo}` +
        (idOpcao ? `?idOpcao=${idOpcao}` : idProduto ? `?idProduto=${idProduto}` : "")
    const headers = { "Content-Type": "application/octet-stream", Authorization: autorizacao }

    try {
        const response = await api.put(url, file, {
            headers: headers,
        })

        console.warn("cadastrarImagem =>", response)

        return tratamentoResponse(response, "cadastrarImagem")
    } catch (error) {
        console.error(error)
        RegistrarLogErro(error, "cadastrarImagem", {})
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const obterCardapioRegistrador = async (idEstabelecimento, Authorization) => {
    try {
        const response = await api.get("cardapio/pedido/" + idEstabelecimento, {
            headers: {
                "Content-Type": "application/json",
                Authorization: Authorization,
            },
        })

        console.warn("obterCardapioRegistrador =>", response)

        return tratamentoResponse(response, "obterCardapioRegistrador")
    } catch (error) {
        console.error(error)
        RegistrarLogErro(error, "obterCardapioRegistrador")
    }
}

export const salvarEdicaoEmMassa = async (idEstabelecimento, data, Authorization) => {
    try {
        const response = await api.post(`cardapio/update/lista/${idEstabelecimento}`, data, {
            headers: {
                "Content-Type": "application/json",
                Authorization: Authorization,
            },
        })

        console.warn("salvarEdicaoEmMassa =>", response)

        return tratamentoResponse(response, "salvarEdicaoEmMassa")
    } catch (error) {
        console.error(error)
        RegistrarLogErro(error, "salvarEdicaoEmMassa", {})
        return { retornoErro: 1, mensagem: error.mensagem }
    }
}

// FASE 1 da IA: interpreta o texto e retorna a LISTA DE AÇÕES (nada é aplicado).
// Retorno esperado: { acoes: [...], resumo } ou { erro }.
export const interpretarCardapioIA = async (texto, autorizacao) => {
    const url = "cardapio-ia/interpretar"
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }
    try {
        const response = await api
            .post(url, { texto }, { headers })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })
        return tratamentoResponse(response, "interpretarCardapioIA")
    } catch (error) {
        RegistrarLogErro(error, "interpretarCardapioIA", { texto })
        return { retornoErro: 1, mensagem: error.message }
    }
}

// FASE 2 da IA: aplica a lista de ações já confirmada e persiste no back.
// Retorno esperado: { cardapio (view atualizada), alteracoesRealizadas, resumo } ou { erro }.
export const executarAcoesCardapioIA = async (acoes, autorizacao) => {
    const url = "cardapio-ia/executar"
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }
    try {
        const response = await api
            .post(url, { acoes }, { headers })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })
        return tratamentoResponse(response, "executarAcoesCardapioIA")
    } catch (error) {
        RegistrarLogErro(error, "executarAcoesCardapioIA", {})
        return { retornoErro: 1, mensagem: error.message }
    }
}

// PRÉ-FASE (comando de voz): transcreve um áudio gravado no navegador em texto, reusando o
// Whisper que o backend já tinha (via ChatGPTService). O texto volta para o usuário revisar
// e então segue o mesmo fluxo do /interpretar. O áudio vai em base64 (JSON) — não há provider
// multipart no backend. Retorno esperado: { texto } ou { erro }.
export const transcreverAudioCardapioIA = async (audioBase64, mimeType, autorizacao) => {
    const url = "cardapio-ia/transcrever"
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }
    try {
        const response = await api
            .post(url, { audioBase64, mimeType }, { headers })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })
        return tratamentoResponse(response, "transcreverAudioCardapioIA")
    } catch (error) {
        RegistrarLogErro(error, "transcreverAudioCardapioIA", {})
        return { retornoErro: 1, mensagem: error.message }
    }
}

// Lista as fotos ja enviadas na pasta de produtos do estabelecimento (para reaproveitar).
// Retorna um array de { valor: url }.
export const ObterImagens = async (idEstabelecimento, Authorization) => {
    try {
        // Sem Content-Type: o endpoint /photos @Consumes octet-stream e rejeita
        // application/json com 415. Como e um GET sem corpo, so mandamos o Authorization.
        const response = await api.get("cardapio/photos/" + idEstabelecimento, {
            headers: {
                Authorization: Authorization,
            },
        })

        return tratamentoResponse(response, "ObterImagens")
    } catch (error) {
        console.error(error)
        RegistrarLogErro(error, "ObterImagens", {})
        return { retornoErro: 1, mensagem: error.message }
    }
}

// Vincula uma imagem JA existente (URL da galeria) a um produto/opcao, sem novo upload.
export const vincularImagemProduto = async (
    idEstabelecimento,
    idProduto,
    idOpcao,
    url,
    Authorization
) => {
    try {
        const params =
            "?url=" +
            encodeURIComponent(url) +
            (idProduto ? "&idProduto=" + idProduto : "") +
            (idOpcao ? "&idOpcao=" + idOpcao : "")

        const response = await api.put(
            "cardapio/photo/vincular/" + idEstabelecimento + params,
            null,
            { headers: { Authorization: Authorization } }
        )

        return tratamentoResponse(response, "vincularImagemProduto")
    } catch (error) {
        console.error(error)
        RegistrarLogErro(error, "vincularImagemProduto", {})
        return { retornoErro: 1, mensagem: error.message }
    }
}

// Lista os backups do cardapio salvos no S3 (a cada alteracao o backend grava um CSV).
// Retorna um array de { valor: url } (padrao Valor), ou { retornoErro, mensagem } em falha.
export const listarHistoricoCardapio = async (idEstabelecimento, Authorization) => {
    try {
        // Sem Content-Type: o endpoint @Consumes octet-stream e rejeita application/json
        // com 415. Como e um GET sem corpo, so mandamos o Authorization (igual ObterImagens).
        const response = await api.get("cardapio/historico/" + idEstabelecimento, {
            headers: {
                Authorization: Authorization,
            },
        })

        return tratamentoResponse(response, "listarHistoricoCardapio")
    } catch (error) {
        console.error(error)
        RegistrarLogErro(error, "listarHistoricoCardapio", {})
        return { retornoErro: 1, mensagem: error.message }
    }
}

// Gera UM unico snapshot do cardapio no historico (S3). Usado no fim de uma importacao
// em lote, quando os cadastros foram feitos com registrarHistorico=false (sem snapshot
// por linha), para gerar apenas um log ao inves de um por item.
export const registrarHistoricoCardapio = async (idEstabelecimento, Authorization) => {
    try {
        const response = await api.post(
            "cardapio/historico/registrar/" + idEstabelecimento,
            {},
            { headers: { Authorization: Authorization } }
        )
        return tratamentoResponse(response, "registrarHistoricoCardapio")
    } catch (error) {
        console.error(error)
        RegistrarLogErro(error, "registrarHistoricoCardapio", {})
        return { retornoErro: 1, mensagem: error.message }
    }
}

// "Apagar e recriar" limpo: inativa o cardapio atual e cria um NOVO vazio (o parametro
// passa a apontar pro novo). Os itens antigos somem do editor, sem apagar nada. Depois
// o chamador importa no cardapio novo. Retorna { idCardapio } do novo cardapio.
export const substituirPorCardapioNovo = async (idEstabelecimento, Authorization) => {
    try {
        const response = await api.post(
            "cardapio/substituir-por-novo/" + idEstabelecimento,
            {},
            { headers: { Authorization: Authorization } }
        )
        return tratamentoResponse(response, "substituirPorCardapioNovo")
    } catch (error) {
        console.error(error)
        RegistrarLogErro(error, "substituirPorCardapioNovo", {})
        return { retornoErro: 1, mensagem: error.message }
    }
}

// Exclui uma foto do S3, se ela nao estiver em uso por Produto/OpcaoProduto.
// Retorna { codErro, mensagem } (codErro=0 quando excluida).
export const ExcluirImagem = async (idEstabelecimento, url, Authorization) => {
    try {
        const response = await api.delete(
            "cardapio/photo/" + idEstabelecimento + "?url=" + encodeURIComponent(url),
            { headers: { Authorization: Authorization } }
        )

        return tratamentoResponse(response, "ExcluirImagem")
    } catch (error) {
        console.error(error)
        RegistrarLogErro(error, "ExcluirImagem", {})
        return { retornoErro: 1, mensagem: error.message }
    }
}
